import { Tabs, Button } from "antd";

import AppLayout from "../../components/Layout";
import { PhonebookTable } from "../../components/Dashboards/Tables/PhonebookTable";

const Campaign = () => {
  const items = [
    {
      label: "Phonebook",
      key: "1",
      children: <PhonebookTable data={[]} />,
    },
  ];

  return (
    <AppLayout moduleName="Campaign">
      <Tabs items={items}></Tabs>
    </AppLayout>
  );
};

export default Campaign;
